"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useResizeObserver_1 = __importDefault(require("./useResizeObserver"));
const throttle_1 = __importDefault(require("lodash/throttle"));
const useThrottledResizeObserver = ({ wait = 250, onResize }) => {
    const [size, setSize] = (0, react_1.useState)({
        width: undefined,
        height: undefined,
        top: undefined,
        left: undefined,
        bottom: undefined,
        right: undefined
    });
    const handleResize = (0, react_1.useMemo)(() => (0, throttle_1.default)((newSize) => {
        if (onResize) {
            onResize(newSize);
        }
        setSize(newSize);
    }, wait), [wait, onResize]);
    (0, react_1.useEffect)(() => () => {
        if (handleResize) {
            handleResize.cancel();
        }
    }, [handleResize]);
    const { ref } = (0, useResizeObserver_1.default)({ onResize: handleResize });
    return {
        ref,
        width: size.width || 0,
        height: size.height || 0,
        top: size.top || 0,
        left: size.left || 0,
        bottom: size.bottom || 0,
        right: size.right || 0
    };
};
exports.default = useThrottledResizeObserver;
//# sourceMappingURL=useThrottledResizeObserver.js.map